import styled from 'styled-components';

import colors from '@constants/colors';

export const FileExtIcon = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin-right: 4px;
  border-radius: 30%;
  background-color: ${colors.NAVY_BLUE_LIGHT};
  font-size: 8px;
  color: ${colors.WHITE};
`;
